import { createContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiV1 } from '../lib/axios';
import { removeTokens, storeTokens } from '../utils/sessionMethods';

export const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const [isLogged, setIsLogged] = useState(false);
  const [loginLoader, setLoginLoader] = useState(false);
  const [user, setUser] = useState({});
  const [isFirstAccess, setIsFirstAccess] = useState(false);
  const [isFirstAccessConfirmed, setIsFirstAccessConfirmed] = useState(false);
  const [firstAccessLoader, setFirstAccessLoader] = useState(false);
  const [phone, setPhone] = useState('');
  
  const [firstLoginPass, setFirstLoginPass] = useState(false);

  const navigate = useNavigate();

  const account = user.account;

  async function login(taxNumber, password, fingerprint, captchaToken) {
    setLoginLoader(true);
    const data = {
      taxNumber,
      password,
      mac: fingerprint,
      captchaToken,
    };

    await apiV1
      .post('/login/session', data)
      .then((response) => {
        setPhone(response.data.phone);

        setIsFirstAccess(response.data.isFirstAccess);

        if (!response.data.isFirstAccess) {
          setFirstLoginPass(true);
        }

        setLoginLoader(false);
      })
      .catch((err) => {
        if (err.response.status === 409) {
          toast.error('Login ou Senha incorretos!');
          setLoginLoader(false);
          return;
        }
        toast.error('Falha ao tentar realizar login!');
        setLoginLoader(false);
      });
  }

  async function login2FA(taxNumber, cod) {
    setLoginLoader(true);

    await apiV1
      .post('/login/authenticate', {
        taxNumber,
        otp: cod,
      })
      .then((response) => {
        setIsLogged(true);

        storeTokens(
          response.data.accessToken,
          response.data.refreshToken,
          response.data.tokenFiducia
        );

        getProfile();

        navigate('/pagina-principal');
      })
      .catch((err) => {
        toast.error('Acesso negado, tente novamente!');
      })
      .finally(() => {
        setLoginLoader(false);
      });
  }

  async function logout() {
    setFirstLoginPass(false);
    removeTokens();
    setIsLogged(false);
    setUser({});
    navigate('/');
  }

  async function getProfile() {
    await apiV1.get(`/person/show`).then((response) => {
      const result = response.data.data;

      localStorage.setItem('name', result.name);
      localStorage.setItem('taxNumber', result.taxNumber);
      // localStorage.setItem("deviceId", fingerprint);
      localStorage.setItem('personId', result.id);
      localStorage.setItem('accountId', result.account.id);
      localStorage.setItem('bank', result.account.bank);
      localStorage.setItem('bankAccount', result.account.bankAccount);
      localStorage.setItem('bankAccountDigit', result.account.bankAccountDigit);
      localStorage.setItem('bankBranch', result.account.bankBranch);
      localStorage.setItem('login', result.login);

      setUser(result);
    });
  }

  async function firstAccessFiducia(token, password, transationalPassword) {
    const data = {
      token,
      password,
      transationalPassword,
    };

    setFirstAccessLoader(true);

    await apiV1
      .post('/login/fiducia/firstAccess', data)
      .then(() => {
        setIsFirstAccess(false);
        setIsFirstAccessConfirmed(true);
        setFirstAccessLoader(false);
      })
      .catch(() => {
        toast.error('Ocorreu um erro! Tente novamente!');
        setFirstAccessLoader(false);
      });
  }

  return (
    <AuthContext.Provider
      value={{
        isLogged,
        loginLoader,
        user,
        account,
        isFirstAccess,
        isFirstAccessConfirmed,
        firstAccessLoader,
        phone,
        firstLoginPass,
        login,
        login2FA,
        logout,
        firstAccessFiducia,
        setIsFirstAccess,
        setIsFirstAccessConfirmed,
        getProfile,
        setFirstLoginPass,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
